import axios from 'axios';

// Create an Axios instance
const http = axios.create({
    baseURL: window.location.origin,
    // ... other settings
});

// Add a request interceptor
http.interceptors.request.use(
    config => {
        // Read the token from localStorage
        const token = localStorage.getItem('wsToken');
        if (token) {
            // Attach the token as a header in the request
            config.headers.Authorization = `Bearer ${token}`;
            config.headers['x-access-token'] = token;
        }
        return config;
    },
    error => {
        // Handle the error
        return Promise.reject(error);
    }
);

export default http;
